import { render, staticRenderFns } from "./MassiveTemplateDownloadCard.vue?vue&type=template&id=13bd4006&scoped=true"
import script from "./MassiveTemplateDownloadCard.vue?vue&type=script&lang=js"
export * from "./MassiveTemplateDownloadCard.vue?vue&type=script&lang=js"
import style0 from "./MassiveTemplateDownloadCard.vue?vue&type=style&index=0&id=13bd4006&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd4006",
  null
  
)

export default component.exports